import { chartColors } from '../../../../variables.style'

const DEFAULT_WIDTH = 1024
const DEFAULT_HEIGHT = 600
const SEGMENT_WIDTH = 25
const STATE_SEGMENT_GAP = 10 // vertical gap between state segments
const AXIS_HEIGHT = 50
const PATH_CURVATURE = 0.5
const LEFT_RIGHT_PADDING = 24
const TOP_BOTTOM_PADDING = 2
const MIN_SEGMENT_HEIGHT = 2
const MIN_FLOW_HEIGHT = 1
const DEFAULT_VALUE_LABEL = 'Patients'

export class SankeyLayout {
  constructor () {
    this.labels = []

    this.width = DEFAULT_WIDTH
    this.height = DEFAULT_HEIGHT
    this.stageLabels = []
    this.stateLabels = []
    this.stateColors = []
    this.demographicColors = []
    this.valueLabel = ''
    this.axisLabel = ''
  }

  get numberOfStages () {
    return this.stageLabels.length
  }

  get numberOfStates () {
    return this.stateLabels.length
  }

  get gapBetweenStages () {
    return Math.floor((this.sankeyChartWidth - this.numberOfStages * SEGMENT_WIDTH) / (this.numberOfStages - 1))
  }

  get sankeyChartHeight () {
    return this.height
  }

  get sankeyChartWidth () {
    return this.width - (LEFT_RIGHT_PADDING * 2)
  }

  get totalStateSegmentHeight () {
    return (this.sankeyChartHeight - AXIS_HEIGHT) - ((this.numberOfStates - 1) * STATE_SEGMENT_GAP) - (2 * TOP_BOTTOM_PADDING)
  }

  setLayout ({ width, height, stageLabels, stateLabels, stateColors, demographicColors, valueLabel, axisLabel }) {
    this.width = this.calculateWidthOrHeight(width) || DEFAULT_WIDTH
    this.height = this.calculateWidthOrHeight(height) || DEFAULT_HEIGHT
    this.stageLabels = stageLabels
    this.stateLabels = stateLabels
    this.stateColors = stateColors || chartColors
    this.demographicColors = demographicColors
    this.valueLabel = valueLabel || DEFAULT_VALUE_LABEL
    this.axisLabel = axisLabel
  }

  getStateColor (state) {
    return this.stateColors[state]
  }

  getDemographicColor (demographicCategory, demographicValue) {
    return this.demographicColors[demographicCategory] && this.demographicColors[demographicCategory][demographicValue]
  }

  calculateWidthOrHeight (widthOrHeight) {
    let result

    if ((typeof widthOrHeight === 'string') && widthOrHeight.includes('px')) {
      result = parseInt(widthOrHeight)
    } else if (typeof widthOrHeight === 'number') {
      result = widthOrHeight
    }

    return result
  }
}

export const CONST = { SEGMENT_WIDTH, STATE_SEGMENT_GAP, AXIS_HEIGHT, LEFT_RIGHT_PADDING, TOP_BOTTOM_PADDING, PATH_CURVATURE, MIN_SEGMENT_HEIGHT, MIN_FLOW_HEIGHT }
